/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Force_Render_All_AudioInputs */



/**
* | output |
* | --- |
* | "Force Render ALL Audio..." |
*
* @param {Force_Render_All_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const force_render_all_audio = /** @type {((inputs?: Force_Render_All_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Force_Render_All_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer le rendu de TOUT l'audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Audiodateien erzwingen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forza il rendering di TUTTI gli audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительное воспроизведение всего звука...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forzar renderizado de TODO el audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制渲染所有音频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのオーディオを強制的にレンダリング...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी ऑडियो को जबरदस्ती रेंडर करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forçar renderização de TODO o áudio...")
	return /** @type {LocalizedString} */ ("Force Render ALL Audio...")
});